import React from 'react';
import { BaseInputProps, Dropdown } from 'ui-builder';
import { DueDateShiftOption } from 'nekst-api';

export interface IfWeekendDropdownProps extends Omit<Omit<BaseInputProps<DueDateShiftOption>, 'source'>, 'label'> {

}

export function IfWeekendDropdown(props: IfWeekendDropdownProps) {
  return (
    <Dropdown
      isDisabled={(data: any) => !!data?.useBusinessDaysCalculation}
      source="ifWeekendShiftTo"
      label="If weekend, shift to"
      placeholder="Don't shift"
      isClearable
      options={[
        {
          label: 'Friday Before',
          value: DueDateShiftOption.FRIDAY,
        },
        {
          label: 'Monday After',
          value: DueDateShiftOption.MONDAY,
        }
      ]}
      {...props}
      mobile_noValueOption="Don't shift"
    />
  );
}
